import React from 'react';
const navigationItems = [
  {
    label: 'bottomNavigation.Student_Life',
    // route: '/students-affairs/facilities',
    scrollTo: 4,
    sectionIndex: 4,
  },
  {
    label: 'bottomNavigation.Admission',
    route: '/admissions/overview',
    // scrollTo: 3,
    sectionIndex: 3,
  },
  {
    label: 'bottomNavigation.Programs',
    // route: '/degree-programs',
    scrollTo: 2,
    sectionIndex: 2,
  },

  {
    label: 'bottomNavigation.Media',
    route: '/news-and-events/media-gallery',
    scrollTo: 7,
    sectionIndex: 7,
  },
];

export { navigationItems };
